/* tslint:disable */

/**
 * Inicialización de la clase CheckboxModel, modelo para los checkbox
 * 
 * *Set CheckboxModel class, check box model*
 * 
 * @access public
 * 
 * @type {class}
 */
export class MinValueModel{
  minimumAmount: number
}
export class CheckboxModel {
  /**
   * Identificación de Checkbox
   * 
   * *Checkbox identification*
   * 
   * @type {string} id
   */
  id: string;

  /**
   * Descripción de Checkbox
   * 
   * *Checkbox description*
   * 
   * @type {string} label
   */
  label: string;

  /**
   * Validación de selección de Checkbox
   * 
   * *Checkbox selection validation*
   * 
   * @type {boolean} checked
   */
  checked: boolean;

  /**
   * Valor de Checkbox
   * 
   * *Checkbox value*
   * 
   * @type {string} value
   */
  value: string;

  /**
   * Verificación de la habilitación de Checkbox
   * 
   * *Checkbox enable validation*
   * 
   * @type {boolean} disabled
   */
  disabled?: boolean;
}

/**
 * Inicialización de la clase SelectModel
 * 
 * *Set SelectModel class*
 * 
 * @access public
 * 
 * @type {class}
 */
export class SelectModel {
  /**
   * Identificación de Select
   * 
   * *Select identification*
   * 
   * @type {string} id
   */
  id: string;

  /**
   * Valor de Select
   * 
   * *Select value*
   * 
   * @type {string} value
   */
  value: string;
}

/**
 * Inicialización de la clase BytteConfigType, modelo para la configuración del escaneo de imágenes
 * 
 * *Set BytteConfigType class, scanning images model*
 * 
 * @access public
 * 
 * @type {class}
 */
export class BytteConfigType {
  /**
     * Licencias para la configuración Bytte para cada sistema operativo
     * 
     * *Licenses to Bytte configuration for each Operative System*
     * 
     * @type {any} licenses
     */
  licenses: any;
  /**
     * Objeto para los tiempo de captura de cada escaneo
     *  
     * *Object to set up times for eah scanning*
     * 
     * @type {object} timeouts
     */
  timeouts: {
    /**
     * Objeto para establecer el tiempo escaneo de la parte de atrás del documento 
     * 
     * *Objeto to set up back document scan time*
     * 
     * @type {object} backDocumentScan
     */
    backDocumentScan: {
      seconds: number,
    },

    /**
     * Objeto para establecer el tiempo escaneo de la huella dáctilar del documetno 
     * 
     * *Objeto to set up fingerprint scan time*
     * 
     * @type {object} fingerPrintsScan
     */
    fingerPrintsScan: {
      seconds: number,
    },

    /**
     *  Objeto para establecer el tiempo escaneo de la parte de adelante del documento 
     *
     * *Objeto to set up front document scan time*
     * 
     * @type {object} frontDocumentScan
     */
    frontDocumentScan: {
      seconds: number,
    },
  };

  /**
   *  Objeto para establecer la cantidad de intentos fallidos 
   * 
   * *Objeto to set up failed attempts for each scanning option*
   * 
   * @type {object} frontDocumentScan
   */
  failedAttempts: {
    backDocumentScan: number,
    fingerPrintsScan: number,
    frontDocumentScan: number,
  };
}


/**
 * Inicialización de la clase DSBMobileConfig
 * 
 * *Set DSBMobileConfig class*
 * 
 * @access public
 * 
 * @type {class}
 */
export class DSBMobileConfig {
  /**
   *  Clave de la licencia para la configuración DSB mobile
   * 
   * *DSB mobile config license key*
   * 
   * @type {string} frontDocumentScan
   */
  licenseKey: string;

  /**
   *  Códigos deshabilitados para la configuración DSB mobile 
   * 
   * *DSB mobile config disallowed codes*
   * 
   * @type {string[]} frontDocumentScan
   */
  disalloweCodes: string[];

  /**
   *  Url seguro para la configuración DSB mobile 
   * 
   * *DSB mobile config secure ur*
   * 
   * @type {string} secureUrl
   */
  secureUrl: string;

  /**
   *  Intentos máximos de conexión para la configuración DSB mobile 
   * 
   * *DSB mobile config connection max attempts*
   * 
   * @type {number} connectionMaxAttempts
   */
  connectionMaxAttempts: number;
}

/**
 * Inicialización de la clase OptionRadioModel, modelo de RadioOption
 * 
 * *Set OptionRadioModel class, RadioOption model*
 * 
 * @access public
 * @type {class}
 */
export class OptionRadioModel {
  /**
   *  Identificación de OptionRadio
   * 
   * *OptionRadio Identification*
   * 
   * @type {number} elementId
   */
  elementId: number;

  /**
   *  Descripción de OptionRadio
   * 
   * *OptionRadio description*
   * 
   * @type {string} label
   */
  label: string;

  /**
   *  Validación de selección de OptionRadio
   * 
   * *OptionRadio selection validation*
   * 
   * @type {number} connectionMaxAttempts
   */
  checked: boolean;

  /**
   *  Nombre del grupo de elementos de OptionRadio
   * 
   * *OptionRadio element group name*
   * 
   * @type {string} elementGroupName
   */
  elementGroupName?: string;
}

/**
 * Inicialización de la clase OptionCheckBoxModel, modelo de CheckBoxOption
 * 
 * *Set OptionCheckBoxModel class, CheckBoxOption model*
 * 
 * @access public
 * @type {class}
 */
export class OptionCheckBoxModel {
  /**
   * OptionCheck Identification
   * @type {number} elementId
   */
  elementId: number;

  /**
   * OptionCheck description
   * @type {string} label
   */
  label: string;

  /**
   * OptionCheck selection validation
   * @type {boolean}
   */
  checked: boolean;

  /**
   * OptionCheck disabled
   * @type {boolean}
   */
  disabled?: boolean;
}
